import Vue, { PluginObject } from 'vue';

export const EventBus: PluginObject<any> = {
    install(VueInstance) {
        const eventBus = new Vue();
        VueInstance.$eventBus = eventBus;
        VueInstance.prototype.$eventBus = eventBus;
    },
};

Vue.use(EventBus);

